/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.status {
  border-radius: var(--radius-sm, 0.25rem);
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-color: transparent;
  padding-inline: calc(var(--spacing, 0.25rem) * 2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: nowrap;
  width: fit-content;
}
.status.large {
  min-height: calc(var(--spacing, 0.25rem) * 8);
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
}
.status.small {
  min-height: calc(var(--spacing, 0.25rem) * 6);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
}
.status.hasBorder {
  border-style: var(--tw-border-style);
  border-width: 1px;
  --tw-border-style: solid;
  border-style: solid;
  border-color: currentcolor;
}
.status svg:first-of-type {
  display: inline-block;
}
.status.noIcon .content {
  grid-template-columns: auto;
}
.status.neutral {
  background-color: var(--color-gray-200, #e5e5e5);
}
.status.success {
  background-color: var(--color-success-light, #dcfce7);
  color: var(--color-success-dark, #15803d);
}
.status.danger {
  background-color: var(--color-danger-light, #fef2f2);
  color: var(--color-danger-dark, #b91c1c);
}
.status.warning {
  background-color: var(--color-warning-light, #ffedd5);
  color: var(--color-warning-dark, #c2410c);
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-font-weight: initial;
      --tw-border-style: solid;
    }
  }
}
